import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Event } from '../../models/event.model';
import { EventsService } from '../../services/events.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-event-details',
  imports: [DatePipe],
  templateUrl: './event-details.component.html',
  styles: ``
})
export class EventDetailsComponent implements OnInit, OnDestroy {
  event?: Event;
  mapSrc?: SafeResourceUrl;
  subscription?: Subscription;

  private eventsService = inject(EventsService);
  private route = inject(ActivatedRoute);
  private sanitizer = inject(DomSanitizer);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id')!;
      this.getEvent(id);
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getEvent(id: string) {
    this.subscription = this.eventsService.get(id).subscribe({
      next: (res) => {
        this.event = res.data;
        if (this.event) {
          const src = this.getSrc(this.event.latitude, this.event.longitude);
          this.mapSrc = this.sanitizer.bypassSecurityTrustResourceUrl(src);
        }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  getSrc(lat: number, long: number) {
    return `https://www.google.com/maps?q=${lat},${long}&output=embed`;
  }
}
